import { Component, Input } from '@angular/core';
import { Profile } from '../../../features/profile/model/profile.model';

@Component({
  selector: 'vota-influencer-profile-card',
  templateUrl: './influencer-profile-card.component.html',
  styleUrl: './influencer-profile-card.component.scss'
})
export class InfluencerProfileCardComponent {
  @Input() profile: Profile | undefined;
}
